<template>
  <div class="member-info">
    <admin-title title="全域账号明细" />

    <card class="member-list">
      <tp-table
        :table-data="qyMemberList"
        :columns="columns"
        :is-page="false"
      />
    </card>
  </div>
</template>

<script>
const columns = [
  {
    label: "平台名称",
    prop: "appName",
    minWidth: "150",
    customRender(h, row) {
      return <p>{ row["appName"] }</p>
    }
  },
  {
    label: "平台ID",
    prop: "appMemberId",
    minWidth: "100",
    customRender(h, row) {
      return <p>{ row["appMemberId"] }</p>
    }
  },
  {
    label: "手机号",
    prop: "mobile",
    minWidth: "120",
    customRender(h, row) {
      return <p>{ row["mobile"] }</p>
    }
  },
  {
    label: "注册时间",
    prop: "registerTime",
    minWidth: "180",
    customRender(h, row) {
      return <p>{ row["registerTime"] }</p>
    }
  },
  {
    label: "可信名单库",
    prop: "rosterList",
    minWidth: "180",
    customRender(h, row) {
      return (
        <div style="display: flex; gap: 5px;">
          <el-tag v-show={ !!row['isBlacklist'] } class="blacklist" size="small">黑名单</el-tag>
          <el-tag v-show={ !!row['isWhitelist'] } class="whitelist" size="small">白名单</el-tag>
        </div>
      )
    }
  },
  {
    label: "申请单量",
    prop: "applyOrderNum",
    minWidth: "100",
    customRender(h, row) {
      return <p>{ row["applyOrderNum"] }</p>
    }
  },
  {
    label: "成单量",
    prop: "dealOrderNum",
    minWidth: "100",
    customRender(h, row) {
      return <p>{ row["dealOrderNum"] }</p>
    }
  },
  {
    label: "结清单量",
    prop: "fullPayOrderNum",
    minWidth: "100",
    customRender(h, row) {
      return <p>{ row["fullPayOrderNum"] }</p>
    }
  },
  {
    label: "在逾/在租单量",
    prop: "overdueRentOrderNum",
    minWidth: "150",
    customRender(h, row) {
      return <p>{ row["inOverdueOrderNum"] } / { row["inRentOrderNum"] }</p>
    }
  },
  // {
  //   label: "最长逾期天数",
  //   prop: "maxOverdueDayNum",
  //   minWidth: "100",
  //   customRender(h, row) {
  //     return <p>{ row["maxOverdueDayNum"] }</p>
  //   }
  // },
  // {
  //   label: "最长延期天数",
  //   prop: "maxExtendDayNum",
  //   minWidth: "100",
  //   customRender(h, row) {
  //     return <p>{ row["maxExtendDayNum"] }</p>
  //   }
  // },
];

export default {
  name: "QyMemberList",

  props: {
    qyMemberList: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      columns,
    };
  },
};
</script>

<style lang="scss" scoped>
.member-info /deep/ {
  width: 100%;
  border: 1px solid #c5c5c5;
  border-radius: 15px;
  padding: 15px 20px;

  .member-list {
    .blacklist {
      color: #ffffff;
      background-color: #000000;
      font-weight: bold;
    }
    .whitelist {
      color: #000000;
      background-color: #ffffff;
      font-weight: bold;
    }
  }
}
</style>
